<template>
  <div>
    <prospecting-opportunities-top :prospectStats="prospectStats" :showAuthError="crmReconnectionRequired"/>

    <tabs @changeTabs="changeTabs" class="ut-mb-10" :navWidth="'76%'">

      <!-- Prospects to call -->
      <tab
        name="To call"
        :selected="true"
        :gacategory="gacategory"
        :gaaction="'Secondary tab menu'"
        :galabel="'To call'">
        <div v-if="prospectsInStageNew.loaded && attentionProspects.loaded"
        class="sm:ut-mx-0 ut--mx-8">
            <!-- Fallback text -->
            <div v-if="prospectsInStageNew.data.length === 0
                       && attentionProspects.data.length === 0"
                 class="ut-text-center ut-mt-6">
              <svg-loader :name="'icon-check'" :width="20" :color-class="'ut-text-green-400'"  />
              <h2 class=" ut-font-bold ut-text-lg ut-mt-4 ut-mb-2">
                Great job {{ userFirstName }}, you're all caught up</h2>
              <p>We'll notify you when a new prospect arrives</p>
            </div>
            <div v-else>
              <div v-if="prospectsInStageNew.data.length > 0" class="ut-mb-12">
                    <prospect-card
                    v-for="prospect in prospectsInStageNew.data"
                    :key="prospect.key"
                    :prospect="prospect"
                    :gacategory="gacategory"
                    :gaaction="'Call tracker - view prospects to call'"/>
              </div>
              <div v-if="attentionProspects.data.length > 0">
                <h2 class="ut-mb-6">Need to follow up on</h2>
                  <prospect-card
                  v-for="prospect in attentionProspects.data"
                  :key="prospect.key"
                  :prospect="prospect"
                  :gacategory="gacategory"
                  :gaaction="'Call tracker - view prospects to call'"/>
              </div>
            </div>
        </div>

        <loading-spinner v-else />
      </tab>

      <!-- Attempted -->
      <tab
        name="Attempted"
        :gacategory="gacategory"
        :gaaction="'Secondary tab menu'"
        :galabel="'Attempted'">
        <div v-if="prospectsInStageAttempted.loaded" class="ut-relative sm:ut-mx-0 ut--mx-8">

          <div v-if="prospectsInStageAttempted.data.length === 0">
            <p class="fallback-text">
              No prospects here right now.
              <a href="#to-call"
                class="ut-text-green-400 ut-block ut-mt-4">See all active prospects</a>
            </p>
          </div>

          <div v-else>
            <select-list
              v-if="attemptedFilterOptions.length > 2 && prospectsInStageAttempted.data.length > 1"
              :options="attemptedFilterOptions"
              v-model="selectedAttemptedFilterOption"
              class="prospect-filter sm:ut-px-0 ut-px-8"
              @input="updateAttemptedFilter"
            />
            <prospect-card
              v-for="(prospect, index) in prospectsInStageAttempted.data"
              :key="index"
              :filterOption="selectedAttemptedFilterOption"
              :prospect="prospect"
              :gacategory="gacategory"
              :gaaction="'Call tracker - view attempted'"/>

          </div>
        </div>
        <loading-spinner v-else />
      </tab>

      <!-- Contact -->
      <tab
        name="Contacted"
        :gacategory="gacategory"
        :gaaction="'Secondary tab menu'"
        :galabel="'Contacted'">
        <div v-if="contactedProspects.loaded" class="ut-relative sm:ut-mx-0 ut--mx-8">
          <div v-if="contactedProspects.data.length == 0">
            <p class="fallback-text">
              No prospects here right now.
              <a href="#to-call"
                class="ut-text-green-400 ut-block ut-mt-4">See all active prospects</a>
            </p>
          </div>
          <div v-else>
            <select-list
              v-if="contactedFilterOptions.length > 2 && contactedProspects.data.length > 1"
              :options="contactedFilterOptions"
              v-model="selectedContactedFilterOption"
              class="prospect-filter sm:ut-px-0 ut-px-8"
              @input="updateContactedFilter"
            />
            <prospect-card
              v-for="(prospect, index) in contactedProspects.data"
              :key="index"
              :filterOption="selectedContactedFilterOption"
              :prospect="prospect"
              :gacategory="gacategory"
              :gaaction="'Call tracker - view prospects contacted'"/>
          </div>
        </div>
        <loading-spinner v-else />
      </tab>

      <!-- Appraisals -->
      <tab
        name="Appraisals"
        :gacategory="gacategory"
        :gaaction="'Secondary tab menu'"
        :galabel="'Appraisals'">
        <div v-if="appraisalProspects.loaded" class="ut-relative sm:ut-mx-0 ut--mx-8">
          <div v-if="appraisalProspects.data.length == 0">
            <p class="fallback-text">
              No prospects here right now.
              <a href="#to-call"
                class="ut-text-green-400 ut-block ut-mt-4">See all active prospects</a>
            </p>
          </div>
          <div v-else>
            <prospect-card
              v-for="(prospect, index) in appraisalProspects.data"
              :key="index"
              :prospect="prospect"
              :gacategory="gacategory"
              :gaaction="'Call tracker - view prospects apprasial'"/>
          </div>
        </div>
        <loading-spinner v-else />
      </tab>

    </tabs>

  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';
import Tab from '@oa-vue/tab/Tab.vue';
import Tabs from '@oa-vue/tabs/Tabs.vue';
import LoadingSpinner from '@/components/Animations/LoadingSpinner.vue';
import ProspectingOpportunitiesTop from '@/components/ProspectingOpportunitiesTop.vue';
import ProspectCard from '@/components/ProspectCard.vue';
import SelectList from '@/components/Forms/SelectList.vue';

export default {
  name: 'prospectingOpportunities',
  components: {
    Tabs,
    Tab,
    ProspectingOpportunitiesTop,
    LoadingSpinner,
    SvgLoader,
    SelectList,
    ProspectCard,
  },
  props: {
    gacategory: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      loadingMoreProspects: false,
      selectedContactedFilterOption: 'all',
      selectedAttemptedFilterOption: 'all',
    };
  },
  computed: {
    ...mapState({
      user: state => state.userStore.user,
      agent: state => state.agentStore.agent,
      attentionProspects: state => state.prospectsStore.attentionProspects,
      contactedProspects: state => state.prospectsStore.contactedProspects,
      appraisalProspects: state => state.prospectsStore.appraisalProspects,
      prospectsInStageNew: state => state.prospectsStore.prospectsInStageNew,
      prospectsInStageAttempted: state => state.prospectsStore.prospectsInStageAttempted,
      prospectStats: state => state.prospectsStore.prospectStats,
      userProspectorStatus: state => state.userStore.userProspectorStatus,
    }),
    ...mapGetters('prospectsStore', [
      'contactedFilterOptions',
      'attemptedFilterOptions',
    ]),
    ...mapGetters('userStore', [
      'crmReconnectionRequired',
    ]),
    userFirstName() {
      return this.user.firstname ? this.user.firstname : '';
    },
  },
  mounted() {},
  watch: {},
  created() {
    if (this.$route.hash === '#prospects-to-call') {
      this.$router.push({
        name: 'prospecting',
        params: { ak: this.$route.params.ak, uk: this.$route.params.uk },
        hash: '#to-call',
      });
    }
    this.changeTabs(this.$route.hash || 'To call');

    if (!this.prospectStats) {
      const payload = {
        agentId: this.agent.id,
      };

      this.loadProspectsStats(payload);
    }
  },
  methods: {
    ...mapActions('prospectsStore', [
      'loadAttentionProspects',
      'loadContactedProspects',
      'loadAppraisalProspects',
      'loadProspectsWithStageNew',
      'loadProspectsWithStageAttempted',
      'loadProspectsStats',
    ]),
    changeTabs(activeTab) {
      const payload = {
        agentId: this.agent.id,
      };

      if (activeTab === 'To call' && (!this.prospectsInStageNew.loaded || !this.attentionProspects.loaded)) {
        if (!this.prospectsInStageNew.loaded) {
          this.loadProspectsWithStageNew(payload);
        }
        if (!this.attentionProspects.loaded) {
          this.loadAttentionProspects(payload);
        }
      } else if (activeTab === 'Attempted' && !this.prospectsInStageAttempted.loaded) {
        this.loadProspectsWithStageAttempted(payload);
      } else if (activeTab === 'Contacted' && !this.contactedProspects.loaded) {
        this.loadContactedProspects(payload);
      } else if (activeTab === 'Appraisals' && !this.appraisalProspects.loaded) {
        this.loadAppraisalProspects(payload);
      } else {
        if (!this.prospectsInStageNew.loaded) {
          this.loadProspectsWithStageNew(payload);
        }
        if (!this.attentionProspects.loaded) {
          this.loadAttentionProspects(payload);
        }
      }
    },
    updateContactedFilter(value) {
      this.selectedContactedFilterOption = value;
      this.contactedFilterOptions.map((option) => {
        const o = option;
        o.selected = o.value === value ? o.selected = true : o.selected = false;
        return o;
      });
    },
    updateAttemptedFilter(value) {
      this.selectedAttemptedFilterOption = value;
      this.attemptedFilterOptions.map((option) => {
        const o = option;
        o.selected = o.value === value ? o.selected = true : o.selected = false;
        return o;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .fallback-text {
    @apply ut-max-w-full ut-text-center ut-m-auto;
    width: 500px;
  }

  .prospect-filter {
    @apply ut-w-full ut-mb-4;

    @screen md {
      width: auto;
      position: absolute;
      right: 0;
      // top: -52px;
    }

    @screen md {
      top: -76px;
    }
  }
</style>
